import { Module } from 'app/library/module/models/module.model';
import { PasswordlessAccess } from 'app/library/passwordless-access/models/passwordless-access.model';
import { IModulePasswordlessAccessQuery } from '../interfaces/module-passwordless-access.query.interface';

export class ModulePasswordlessAccess extends PasswordlessAccess {
    module: Module;

    constructor(query: IModulePasswordlessAccessQuery) {
        super(query);
        this.module = new Module(query.module);
    }
}
